export default __webpack_public_path__ + "static/media/about-payment-limits.ceff7437.svg";